"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntercomWidget = void 0;

var utils_1 = require("../../lib/utils");

var intercomWindow = window;

var IntercomWidget = /*#__PURE__*/function () {
  function IntercomWidget() {
    _classCallCheck(this, IntercomWidget);
  }

  _createClass(IntercomWidget, [{
    key: "init",
    value: function init(appId, settings) {
      this.appId = appId;

      if (settings) {
        this.settings = settings;
      }
    }
  }, {
    key: "inject",
    value: function inject() {
      var _this = this;

      return new Promise(function (resolve) {
        if (_this.isInjected()) {
          return resolve();
        }

        var script = utils_1.insertScript({
          src: "https://widget.intercom.io/widget/".concat(_this._appId)
        });
        script.addEventListener('load', function () {
          return resolve();
        }, true);
      }).then(function () {
        _this.client = getWindowClient(_this._appId);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.client('reattach_activator');
      this.client('update', Object.assign(Object.assign({}, data), {
        app_id: this._appId
      }));
    }
  }, {
    key: "showNewMessage",
    value: function showNewMessage(text) {
      this.client('showNewMessage', text);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.client('shutdown');
    }
  }, {
    key: "isInjected",
    value: function isInjected() {
      return _isInjected();
    }
  }, {
    key: "appId",
    set: function set(id) {
      this._appId = id;
      this.client = getWindowClient(id);
    },
    get: function get() {
      return this._appId;
    }
  }, {
    key: "settings",
    set: function set(settings) {
      this._settings = settings;
      intercomWindow.intercomSettings = settings;
    },
    get: function get() {
      return this._settings;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new IntercomWidget();
      }

      return this.instance;
    }
  }]);

  return IntercomWidget;
}();

exports.IntercomWidget = IntercomWidget;

function getWindowClient(appId) {
  return function () {
    if (!appId) {
      return console.warn('Intercom app id empty. Check that the environment is propery set');
    }

    if (utils_1.isMobile()) {
      return;
    }

    if (!_isInjected()) {
      return console.warn('Intercom called before injection');
    }

    intercomWindow.Intercom.apply(intercomWindow, arguments);
  };
}

function _isInjected() {
  return typeof intercomWindow.Intercom === 'function';
}